import moment from "moment";
import { LoadState } from "../../../constants/enums";
import {  getUniqueId } from "../../../helpers";
import { STANDARD_APP_DATE_FORMAT } from "../../../constants/constants";

export interface IAccountingBillState {
  list: IBillTransactionItem[];
  listLoading: LoadState;
  data: IAccountingBill;
  loading: LoadState;
  error: string | null;
  bill_history: IAccountingBillHistory;
  billHistoryLoading: LoadState;
}

export interface IBillTransactionItem {
  accn_bill_transaction_items_id: number | null;
  accn_transaction_id: number | null;
  account: string | null;
  amount: string | null;
  bill_date: string | null;
  bill_id: number | null;
  bill_number: string | null;
  bill_transaction_date: string | null;
  bill_type: string | null;
  category: string | null;
  code: string | null;
  commission_paid: string | null;
  create_ts: string | null;
  created_by_id: number | null;
  current_amount_due: string;
  customer_id: number | null;
  description: string | null;
  detail: string | null;
  due_date: string | null;
  final_amount: string | null;
  gl_sales_account_name: string | null;
  insert_ts: string | null;
  invoice_id: number | null;
  invoice_transaction_id: number | null;
  modified_by_id: number | null;
  payment_paid: string | null;
  payment_paid_date: string | null;
  payment_terms: string | null;
  reconciled: string | null;
  reconciled_date: string | null;
  status: string;
  tax_amount: string | null;
  tax_percentage: string | null;
  total_due_amount: string;
  transaction_type: string | null;
  vendor: string | null;
  vendor_type: string;
  customer_policy_id: string | null;
  bill_payment_type: string | null;
  paid_to: string | null;
}


export interface IAccountingBillDetail {
  key: string;
  transaction_type: string | null;
  detail: string;
  account: string;
  description: string;
  tax_percentage: string;
  tax_amount: string;
  amount: string;
  final_amount: string;
  commission_paid:string | null;
  payment_paid_date: string | null;
  reconciled: string | null;
  status?: string
  accn_transaction_id?: number;
  bill_transaction_date: string | null;

}

export interface IAccountingBill {
  accn_create_bill_id: number;
  customer_id: string | null;
  accn_create_payment_id?: string | null;
  customer_policy_id: string | null;
  bill_id: string | null;
  bill_type: string | null;
  vendor_type: string | null;
  vendor: string | null;
  code: string | null;
  category: string | null;
  bill_date: string | null;
  due_date: string | null;
  bill_number: string | null;
  payment_terms: string | null;
  bill_details: IAccountingBillDetail[];
  bill_information: string | null;
  bill_notes: string | null;
  bill_footer_information: string | null;
  sub_total_amount: string;
  discount_percentage: string;
  discount_amount: string;
  adjustment_percentage: string;
  adjustment_amount: string;
  total_tax_amount: string;
  amount_due: string;
  status: string;
  amount_paid: string;
  total_due_amount: string;
  accounting_information_id: string | null;
  gl_sales_account_name: string | null;
  paid_to: string | null;
  bill_payment_type: string | null;
    reconciled?: string | null;
  reconciled_date?: string | null;
  
}

export interface IBulkBill {
  accn_create_bill_id: number;
  customer_id: string | null;
  customer_policy_id: string | null;
  accn_create_payment_id?: string | null;
  bill_id: string | null;
  bill_type: string | null;
  vendor_type: string | null;
  code: string | null;
  paid_to: string | null;
  bill_notes: string | null;
  bill_payment_type: string | null;
  category: string | null;
  vendor: string | null;
  bill_transaction_date: string | null;
  bill_date: string | null;
  due_date: string | null;
  bill_number: string | null;
  payment_terms: string | null;
  transaction_type: string | null;
  detail: string | null;
  account: string | null;
  description: string | null;
  tax_percentage: string | null;
  tax_amount: string | null;
  amount: string | null;
  final_amount: string | null;
  gl_expense_account: string | null;
  status?: string
  accn_transaction_id?: number;
}

export interface IBulkBillRow {
  key: string;
  accn_create_bill_id: number;
  customer_id: string | null;
  customer_policy_id: string | null;
  accn_create_payment_id?: string | null;
  bill_id: string | null;
  bill_type: string | null;
  vendor_type: string | null;
  code: string | null;
  paid_to: string | null; 
  bill_notes: string | null;
  bill_payment_type: string | null;
  category: string | null;
  vendor: string | null;
  bill_date: string | null;
  bill_transaction_date: string | null;
  due_date: string | null;
  bill_number: string | null;
  payment_terms: string | null;
  transaction_type: string | null;
  detail: string | null;
  account: string | null;
  description: string | null;
  tax_percentage: string | null;
  tax_amount: string | null;
  amount: string | null;
  final_amount: string | null;
  gl_expense_account: string | null;
}

export interface IAccountingBillHistory {
  accn_create_bill_id: string | null;
  customer_id: string | null;
  customer_policy_id: string | null;
  bill_id: string | null;
  bill_number: string | null;
  vendor: string | null;
  code: string | null;
  vendor_type: string | null;
  category: string | null;
  bill_date: string | null;
  due_date: string | null;
  payment_terms: string | null;
  gl_expense_account: string | null;
  gl_sales_account_name: string | null;
  bill_type: string | null;
  bill_notes: string | null;
  bill_footer_information: string | null;
  sub_total_amount: string | null;
  discount_percentage: string | null;
  discount_amount: string | null;
  adjustment_percentage: string | null;
  adjustment_amount: string | null;
  total_tax_amount: string | null;
  amount_due: string | null;
  amount_paid: string | null;
  total_due_amount: string | null;
  accounting_information_id: string | null;
  status: string | null;
  created_by_id: string | null;
  create_ts: string | null;
  insert_ts: string | null;
  payment_paid: string | null;
  remaining_amount_due: string | null;
  bill_details: IAccountingBillDetail[];
  bill_payment_details: IAccountingBillPayment[];
}

export interface IAccountingBillPayment {
  accn_payment_payable_details_id: string | null;
  payment_id: string | null;
  accn_transaction_id: string | null;
  create_payment_code: string | null;
  create_payment_id: string | null;
  vendor: string | null;
  invoice_payment_gl_account_name: string | null;
  payment_number: string | null;
  payment_made: string | null;
  bank_charges: string | null;
  payment_method: string | null;
  paid_through_account: string | null;
  date: string | null;
  payment_paid: string | null;
  amount_due: string | null;
  bill_amount: string | null;
  bill_number: string | null;
  total_amount: string | null;
  is_partial_payment: string | null;
  status: string | null;
  created_by_id: string | null;
  modified_by_id: string | null;
  create_ts: string | null;
  insert_ts: "2024-10-22T10:30:15.000Z";
  customer_id: string | null;
  detail: string | null;
  account: string | null;
  description: string | null;
  tax_percentage: string | null;
  tax_amount: string | null;
  amount: string | null;
  final_amount: string | null;
  vendor_type: string | null;
  category: string | null;
  bill_date: string | null;
  bill_id: string | null;
  bill_type: string | null;
  due_date: string | null;
  payment_terms: string | null;
  total_due_amount: string | null;
}

export const initialAccountingBillState: IAccountingBillState = {
  list: [],
  listLoading: LoadState.NotLoaded,
  data: {
    accn_create_bill_id: 0,
    customer_id: null,
    customer_policy_id: null,
    bill_id: null,
    bill_type: null,
    vendor_type: null,
    vendor: null,
    code: null,
    bill_number: null,
    category: null,
    bill_date: moment().format(STANDARD_APP_DATE_FORMAT),
    due_date:  moment().format(STANDARD_APP_DATE_FORMAT),
    payment_terms: null,
    bill_details: [
      {
        key: getUniqueId(),
        detail: "",
        account: "",
        transaction_type: null,
        description: "",
        tax_percentage: "",
        tax_amount: "",
        amount: "",
        final_amount: "",
        commission_paid: "N",
        payment_paid_date: null,
        reconciled: "N",
        bill_transaction_date: null,
      },
    ],
    bill_information: null,
    bill_notes: null,
    bill_footer_information: null,
    sub_total_amount: "",
    discount_percentage: "",
    discount_amount: "",
    adjustment_percentage: "",
    adjustment_amount: "",
    amount_due: "",
    total_tax_amount: "",
    status: "ACTIVE",
    amount_paid: "",
    total_due_amount: "",
    accounting_information_id: null,
    gl_sales_account_name: null,
    bill_payment_type: null,
    paid_to: null,
  },
  loading: LoadState.NotLoaded,
  error: null,
  bill_history: {
    accn_create_bill_id: null,
    customer_id: null,
    customer_policy_id: null,
    bill_id: null,
    bill_number: null,
    vendor: null,
    code: null,
    vendor_type: null,
    category: null,
    bill_date: null,
    due_date: null,
    payment_terms: null,
    gl_expense_account: null,
    gl_sales_account_name: null,
    bill_type: null,
    bill_notes: null,
    bill_footer_information: null,
    sub_total_amount: null,
    discount_percentage: null,
    discount_amount: null,
    adjustment_percentage: null,
    adjustment_amount: null,
    total_tax_amount: null,
    amount_due: null,
    amount_paid: null,
    total_due_amount: null,
    accounting_information_id: null,
    status: null,
    created_by_id: null,
    create_ts: null,
    insert_ts: null,
    payment_paid: null,
    remaining_amount_due: null,
    bill_details: [],
    bill_payment_details: [],
  },
  billHistoryLoading: LoadState.NotLoaded,
};


export const  initialBillTransactionItem: IBillTransactionItem = {
  accn_bill_transaction_items_id: null,
  accn_transaction_id: null,
  account: null,
  amount: null,
  bill_date: null,
  bill_id: null,
  bill_number: null,
  bill_transaction_date: null,
  bill_type: null,
  category: null,
  code: null,
  commission_paid: null,
  create_ts: null,
  created_by_id: null,
  current_amount_due: "",
  customer_id: null,
  description: null,
  detail: null,
  due_date: null,
  final_amount: null,
  gl_sales_account_name: null,
  insert_ts: null,
  invoice_id: null,
  invoice_transaction_id: null,
  modified_by_id: null,
  payment_paid: null,
  payment_paid_date: null,
  payment_terms: null,
  reconciled: null,
  reconciled_date: null,
  status: "ACTIVE",
  tax_amount: null,
  tax_percentage: null,
  total_due_amount: "",
  transaction_type: null,
  vendor: null,
  vendor_type: "",
  bill_payment_type: null,
  customer_policy_id: null,
  paid_to: null,

}